import { SnackbarModel, SNACKBAR_LEVELS } from '@/common/types'

export const MAX_SLIDER_IMAGE_COUNT = 5

export enum SERVER_ERRORS {
  NO_TRIAL_SUPPORT = 'GP001'
}

export const CAROUSEL_ITEM_LIMIT = 5

export enum PRODUCT_IMAGE_TYPES {
  PRODUCT = 'product',
  FABRIC = 'fabric',
  WEARING = 'wearing',
  EXPLANATION = 'explanation',
  FUNCTIONAL = 'functional'
}

export const ADDON_PRODUCT_NONE = 'NONE'

export const PRODUCT_INVALID_SELECTIONS: SnackbarModel = {
  id: 'SBW03',
  content: '入力内容に不備があります。\nメッセージが表示された箇所をご確認ください。',
  level: SNACKBAR_LEVELS.ERROR,
  showButton: false,
  duration: 4000,
  isShown: false
}

export const LOCAL_STORAGE_KEY = {
  PRODUCT_DETAIL_PREFECTURE: 'product_detail_selected_prefecture'
}

export enum SHIPPING_OPTIONS {
  NORMAL = 'normal',
  SAME_DAY = 'same_day',
  NEXT_DAY = 'next_day',
}
